import { generateClient, get, isCancelError, post } from "aws-amplify/api";
import { getUrl } from "aws-amplify/storage";

const client = generateClient();

export async function requestGetPointBalance(dispatch) {
  try {
    dispatch({
      type: "REQUEST_GET_POINT_BALANCE",
      payload: { request: null },
    });

    const request = get({
      apiName: "point",
      path: "/balance",
    });

    dispatch({
      type: "REQUEST_GET_POINT_BALANCE",
      payload: { request },
    });

    const response = await request.response;
    const result = await response.body.json();

    dispatch({
      type: "REQUEST_GET_POINT_BALANCE_SUCCESS",
      payload: { balance: result.data },
    });
  } catch (error) {
    dispatch({ type: "REQUEST_GET_POINT_BALANCE_ERROR", payload: { error } });
  }
}

export async function requestListPointTransaction(dispatch, payload) {
  try {
    const {
      owner,
      page,
      limit = 10,
      createdAt,
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_POINT_TRANSACTION",
      payload: { page },
    });
    const params = {
      owner,
      limit,
      sortDirection,
      nextToken,
    };
    if (createdAt) {
      params.createdAt = createdAt;
    }
    const res = await client.graphql({
      query: pointTransactionsByOwnerCreatedAt,
      variables: params,
    });
    const { items, nextToken: token } =
      res.data.pointTransactionsByOwnerCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "SUCCESS_LIST_POINT_TRANSACTION",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({
      type: "ERROR_LIST_POINT_TRANSACTION",
      error,
    });
  }
}

export async function requestListRewardsProduct(dispatch, payload) {
  try {
    const { page, limit, nextToken = null } = payload;

    dispatch({
      type: "REQUEST_LIST_REWARDS_PRODUCT",
      payload: { request: null, page },
    });

    const params = {
      nextToken,
      limit,
    };

    const request = client.graphql({
      query: listRewardsProducts,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_REWARDS_PRODUCT",
      payload: { request, page },
    });

    const res = await request;
    let { items } = res.data.listRewardsProducts;
    const { nextToken: token } = res.data.listRewardsProducts;

    items = await Promise.all(
      items.map(async (item) => {
        if (item.image?.path) {
          const urlResult = await getUrl({
            path: item.image.path,
            options: {
              useAccelerateEndpoint: true,
            },
          });
          const signedUrl = urlResult.url.href;
          return {
            ...item,
            imageUrl: signedUrl,
          };
        }
        return item;
      })
    );

    const nextPage = page + 1;

    dispatch({
      type: "LIST_REWARDS_PRODUCT_SUCCESS",
      payload: { products: items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "LIST_REWARDS_PRODUCT_ERROR", error: null });
    } else {
      dispatch({ type: "LIST_REWARDS_PRODUCT_ERROR", error });
    }
  }
}

export async function requestGetRewardsProduct(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_GET_REWARDS_PRODUCT",
      payload: { request: null },
    });

    const { id } = payload;

    const request = client.graphql({
      query: getRewardsProduct,
      variables: { id },
    });

    dispatch({ type: "REQUEST_GET_REWARDS_PRODUCT", payload: { request } });

    const res = await request;
    const product = res.data.getRewardsProduct;

    if (!product) {
      throw new Error("rewardProductNotFound");
    }

    if (product.image?.path) {
      const urlResult = await getUrl({
        path: product.image.path,
        options: {
          useAccelerateEndpoint: true,
        },
      });
      product.imageUrl = urlResult.url.href;
    }

    dispatch({
      type: "GET_REWARDS_PRODUCT_SUCCESS",
      payload: { product },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "GET_REWARDS_PRODUCT_ERROR", error: null });
    } else {
      dispatch({ type: "GET_REWARDS_PRODUCT_ERROR", error });
    }
  }
}

export async function requestRedeemPoint(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_REDEEM_POINT",
      payload: { request: null },
    });
    const { input } = payload;

    const request = post({
      apiName: "point",
      path: "/redeem",
      options: {
        body: input,
      },
    });

    dispatch({
      type: "REQUEST_REDEEM_POINT",
      payload: { request },
    });

    const response = await request.response;
    const result = await response.body.json();

    dispatch({
      type: "REDEEM_POINT_SUCCESS",
      payload: { redemption: result.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "REDEEM_POINT_ERROR", error: null });
    } else {
      dispatch({
        type: "REDEEM_POINT_ERROR",
        error,
      });
    }
  }
}

export async function requestGetRewardsRedemption(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_GET_REWARDS_REDEMPTION",
      payload: { request: null },
    });

    const { id } = payload;

    const request = client.graphql({
      query: getRewardsRedemption,
      variables: { id },
    });

    dispatch({
      type: "REQUEST_GET_REWARDS_REDEMPTION",
      payload: { request },
    });

    const res = await request;
    const redemption = res.data.getRewardsRedemption;

    if (!redemption) {
      throw new Error("redemptionNotFound");
    }

    if (redemption.rewardProduct?.image?.path) {
      const urlResult = await getUrl({
        path: redemption.rewardProduct.image.path,
        options: {
          useAccelerateEndpoint: true,
        },
      });
      redemption.rewardProduct.imageUrl = urlResult.url.href;
    }

    dispatch({
      type: "GET_REWARDS_REDEMPTION_SUCCESS",
      payload: { redemption },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "GET_REWARDS_REDEMPTION_ERROR", error: null });
    } else {
      dispatch({ type: "GET_REWARDS_REDEMPTION_ERROR", error });
    }
  }
}

export async function requestListRewardsRedemption(dispatch, payload) {
  try {
    const {
      owner,
      page,
      limit = 10,
      createdAt,
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_REWARDS_REDEMPTION",
      payload: { request: null, page },
    });

    const params = {
      owner,
      limit,
      sortDirection,
      nextToken,
    };

    if (createdAt) {
      params.createdAt = createdAt;
    }

    const request = client.graphql({
      query: redemptionsByOwnerCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_REWARDS_REDEMPTION",
      payload: { request, page },
    });

    const res = await request;
    let { items } = res.data.redemptionsByOwnerCreatedAt;
    const { nextToken: token } = res.data.redemptionsByOwnerCreatedAt;

    // Get signed URLs for product images
    items = await Promise.all(
      items.map(async (item) => {
        if (item.rewardProduct?.image?.path) {
          const urlResult = await getUrl({
            path: item.rewardProduct.image.path,
            options: {
              useAccelerateEndpoint: true,
            },
          });
          return {
            ...item,
            rewardProduct: {
              ...item.rewardProduct,
              imageUrl: urlResult.url.href,
            },
          };
        }
        return item;
      })
    );

    const nextPage = page + 1;

    dispatch({
      type: "LIST_REWARDS_REDEMPTION_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "LIST_REWARDS_REDEMPTION_ERROR", error: null });
    } else {
      dispatch({ type: "LIST_REWARDS_REDEMPTION_ERROR", error });
    }
  }
}

export async function clearRedeemPoint(dispatch) {
  dispatch({ type: "CLEAR_REDEEM_POINT" });
}

const pointTransactionsByOwnerCreatedAt = /* GraphQL */ `
  query PointTransactionsByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pointTransactionsByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        transactionType
        transactionID
        transaction {
          id
          status
          orderType
          totalPay
          paymentType
          paymentNumber
          paymentDestinationName
          voucher
          totalDiscount
          actions
          userID
          description
          createdAt
          updatedAt
          expiredAt
        }
        referralID
        total
        fee
        description
        owner
        createdAt
        expiredAt
        updatedAt
      }
      nextToken
    }
  }
`;

const listRewardsProducts = /* GraphQL */ `
  query ListRewardsProducts(
    $filter: ModelRewardsProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRewardsProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isActive
        availableStock
        name
        description
        image {
          bucket
          region
          key
          identityId
          path
        }
        terms
        point
        basePoint
        type
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getRewardsProduct = /* GraphQL */ `
  query GetRewardsProduct($id: ID!) {
    getRewardsProduct(id: $id) {
      id
      isActive
      availableStock
      name
      description
      image {
        bucket
        region
        key
        identityId
        path
      }
      terms
      point
      basePoint
      type
      createdAt
      updatedAt
    }
  }
`;

const getRewardsRedemption = /* GraphQL */ `
  query GetRewardsRedemption($id: ID!) {
    getRewardsRedemption(id: $id) {
      id
      rewardProductID
      rewardProduct {
        id
        isActive
        availableStock
        name
        description
        image {
          bucket
          region
          key
          identityId
          path
        }
        terms
        point
        basePoint
        type
        createdAt
        updatedAt
      }
      quantity
      productSnapshot
      pointTransactionID
      pointTransaction {
        id
        status
        transactionType
        total
        fee
        description
        createdAt
        expiredAt
        updatedAt
      }
      detail {
        name
        phone
        email
        address {
          street
          city
          province
          postalCode
        }
      }
      status
      shippingDetails {
        carrier
        trackingNumber
        estimatedDeliveryDate
        shippedAt
        shippingStatus
        notes
      }
      voucherID
      voucher {
        id
        voucher {
          id
          title
          description
          category
          type
          total
          maxDiscount
          limit
        }
        claimedAt
        createdAt
        updatedAt
      }
      reference
      createdAt
      expiredAt
      deliveredAt
      updatedAt
    }
  }
`;

const redemptionsByOwnerCreatedAt = /* GraphQL */ `
  query RedemptionsByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRewardsRedemptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    redemptionsByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        rewardProductID
        rewardProduct {
          id
          isActive
          availableStock
          name
          description
          image {
            bucket
            region
            key
            identityId
            path
          }
          terms
          point
          basePoint
          type
          createdAt
          updatedAt
        }
        quantity
        productSnapshot
        pointTransactionID
        pointTransaction {
          id
          status
          transactionType
          total
          fee
          description
          createdAt
          expiredAt
          updatedAt
        }
        detail {
          phone
          email
          address {
            street
            city
            province
            postalCode
          }
        }
        voucherID
        voucher {
          id
          voucher {
            id
            title
            description
            category
            type
            total
            maxDiscount
            limit
          }
          claimedAt
          createdAt
          updatedAt
        }
        status
        createdAt
        expiredAt
        deliveredAt
        updatedAt
      }
      nextToken
    }
  }
`;
